import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BackButton from '../../../components/UI/BackButton';
import { translate, formatData, isNullOrEmpty } from '../../../utils/util';

const TransmissionDetail = (props) => {
    const item = props.transmission || {};

    const formatJson = (jsonText) => {
        try {
            return JSON.stringify(JSON.parse(jsonText), null, 2);

        } catch (error) {
            return jsonText;
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '5px' }}>
                        <div className="row" style={{ marginBottom: '0' }}>
                            <div className="subtitle col s12" style={{ padding: '0px' }}>
                                <span className="field f-1r">{translate('line-picking:transmission.callDetails')}</span>
                            </div>
                            <div className="row">
                                <div className="input-field no-padding col s6">
                                    <span className="field f-1r">{item?.orderCode}</span>
                                    <label className="active" htmlFor="entryCode">{translate('line-picking:transmission.call')}</label>
                                </div>
                                <div className="input-field no-padding col s4">
                                    <span className="field f-1r">{item?.operation}</span>
                                    <label className="active">{translate('line-picking:transmission.operation')}</label>
                                </div>
                                {
                                    item?.success && (
                                        <div className="input-field no-padding col s12">
                                            <span className="field f-1r">{formatData(item?.updateOn || '')}</span>
                                            <label className="active">{translate('line-picking:transmission.send')}</label>
                                        </div>
                                    )}
                                {
                                    !isNullOrEmpty(item.attempt) && parseInt(item.attempt) > 1 && (
                                        <div className="input-field no-padding col s12">
                                            <span className="field f-1r">{formatData(item?.createOn || '')}</span>
                                            <label className="active">{translate('line-picking:transmission.erro-send')}</label>
                                        </div>
                                    )}
                            </div>
                            <div className="row" style={{ paddingLeft: '20px' }}>
                                <div className="input-field no-padding col s12">
                                    <pre className="field f-1r" style={{ padding: '0px' }}>{formatJson(item?.dataSend)}</pre>
                                    <label className="active" htmlFor="nivel">JSON</label>
                                </div>
                            </div>
                            <div className="row" style={{ paddingLeft: '20px' }}>
                                <div className="input-field no-padding col s12">
                                    <pre className="field f-1r" style={{ padding: '0px' }}>{formatJson(item?.message)}</pre>
                                    <label className="active" htmlFor="nivel">{translate('line-picking:transmission.message')}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        transmission: state.linePickingReducer.transmission
    };
};

const mapDispatchToProps = () => {
    return {
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TransmissionDetail)));
